import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "fields", "preview", "previewText"]
  static values = { clientData: Object }

  connect() {
    this.toggle()
  }

  toggle() {
    const option = this.selectTarget.selectedOptions[0]
    const count = parseInt(option.dataset.placeholders || "0")
    const body = option.dataset.body || ""
    let sampleValues = {}
    let mappings = {}
    try { sampleValues = JSON.parse(option.dataset.sampleValues || "{}") } catch(e) {}
    try { mappings = JSON.parse(option.dataset.mappings || "{}") } catch(e) {}

    const clientData = this.hasClientDataValue ? this.clientDataValue : {}

    this.currentBody = body
    this.fieldsTarget.innerHTML = ""

    for (let i = 1; i <= count; i++) {
      const mapping = mappings[i.toString()] || ""
      let value = ""
      let isAuto = false

      if (mapping && mapping.startsWith("Client.")) {
        const field = mapping.split(".")[1]
        if (clientData[field]) {
          value = clientData[field]
          isAuto = true
        }
      }

      if (!value) {
        value = sampleValues[i.toString()] || ""
      }

      const div = document.createElement("div")
      div.innerHTML = `
        <label class="block text-xs font-medium text-gray-500 mb-1">
          {{${i}}}${isAuto ? ' <span class="text-green-600">(auto)</span>' : ''}
        </label>
        <input type="text" name="variables[${i}]" value="${this.escapeHtml(value)}"
               placeholder="Variable ${i}"
               data-var-index="${i}"
               data-action="input->template-variables#updatePreview"
               class="block w-full rounded-md border-gray-300 shadow-sm focus:border-orange-500 focus:ring-orange-500 text-sm" />
      `
      this.fieldsTarget.appendChild(div)
    }

    this.updatePreview()
  }

  updatePreview() {
    if (!this.hasPreviewTextTarget) return

    let text = this.escapeHtml(this.currentBody || "")
    const inputs = this.fieldsTarget.querySelectorAll("input[data-var-index]")

    inputs.forEach(input => {
      const idx = input.dataset.varIndex
      const value = input.value || `[Variable ${idx}]`
      text = text.replace(
        new RegExp(`\\{\\{${idx}\\}\\}`, "g"),
        `<b><i>${this.escapeHtml(value)}</i></b>`
      )
    })

    this.previewTextTarget.innerHTML = text
  }

  escapeHtml(str) {
    const div = document.createElement("div")
    div.textContent = str
    return div.innerHTML
  }
}
